import { render, staticRenderFns } from "./EventsContestantsCreateDialogMemberSelectItem.vue?vue&type=template&id=a209cda6&"
import script from "./EventsContestantsCreateDialogMemberSelectItem.vue?vue&type=script&lang=ts&"
export * from "./EventsContestantsCreateDialogMemberSelectItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports